import React from 'react';
import PropTypes from 'prop-types';
import {Container} from 'semantic-ui-react';

import './roundedContainer.scss';

const RoundedContainer = ({title, children, ...props}) => {
  return (
    <Container className="mhd--rounded-container" {...props}>
      {title && <div className="title">{title}</div>}

      <div className="content">{children}</div>
    </Container>
  );
};

RoundedContainer.defaultProps = {
  title: null,
};

RoundedContainer.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.any,
};

export default RoundedContainer;



// WEBPACK FOOTER //
// ./src/components/Common/Structure/RoundedContainer.js